module.exports = __webpack_public_path__ + "static/media/save-search-icon.a640febd.svg";